module.exports = __webpack_public_path__ + "img/ou.fa4a0e15.jpg";